import { useReducer } from 'react';

// ---------------------------------------------------------------------------
// Filter / visibility state
// ---------------------------------------------------------------------------

export interface FilterState {
  searchText: string;
  hiddenCostTypeColumns: string[];
  hiddenDirectCostSummaryColumns: string[];
  hiddenFields: string[];
  hiddenResourcePhases: string[];
  hiddenCostPhases: string[];
}

export type FilterAction =
  | { type: 'SET_SEARCH_TEXT'; payload: string }
  | { type: 'SET_HIDDEN_COST_TYPE_COLUMNS'; payload: string[] }
  | { type: 'SET_HIDDEN_DIRECT_COST_SUMMARY_COLUMNS'; payload: string[] }
  | { type: 'SET_HIDDEN_FIELDS'; payload: string[] }
  | { type: 'SET_HIDDEN_RESOURCE_PHASES'; payload: string[] }
  | { type: 'SET_HIDDEN_COST_PHASES'; payload: string[] };

const filterInitialState: FilterState = {
  searchText: '',
  hiddenCostTypeColumns: [],
  hiddenDirectCostSummaryColumns: [],
  hiddenFields: [],
  hiddenResourcePhases: [],
  hiddenCostPhases: [],
};

export const filterReducer = (state: FilterState, action: FilterAction): FilterState => {
  switch (action.type) {
    case 'SET_SEARCH_TEXT':
      return { ...state, searchText: action.payload };
    case 'SET_HIDDEN_COST_TYPE_COLUMNS':
      return { ...state, hiddenCostTypeColumns: action.payload };
    case 'SET_HIDDEN_DIRECT_COST_SUMMARY_COLUMNS':
      return { ...state, hiddenDirectCostSummaryColumns: action.payload };
    case 'SET_HIDDEN_FIELDS':
      return { ...state, hiddenFields: action.payload };
    case 'SET_HIDDEN_RESOURCE_PHASES':
      return { ...state, hiddenResourcePhases: action.payload };
    case 'SET_HIDDEN_COST_PHASES':
      return { ...state, hiddenCostPhases: action.payload };
    default:
      return state;
  }
};

export const useFilterState = () => useReducer(filterReducer, filterInitialState);

// ---------------------------------------------------------------------------
// Modal stack state
// ---------------------------------------------------------------------------

export interface ModalState {
  resourceDetailItemIds: string[];
  costDetailItemIds: string[];
}

export type ModalAction =
  | { type: 'PUSH_RESOURCE_DETAIL_ITEM'; payload: string }
  | { type: 'POP_RESOURCE_DETAIL_ITEM' }
  | { type: 'PUSH_COST_DETAIL_ITEM'; payload: string }
  | { type: 'POP_COST_DETAIL_ITEM' };

const modalInitialState: ModalState = {
  resourceDetailItemIds: [],
  costDetailItemIds: [],
};

export const modalReducer = (state: ModalState, action: ModalAction): ModalState => {
  switch (action.type) {
    case 'PUSH_RESOURCE_DETAIL_ITEM':
      return { ...state, resourceDetailItemIds: [...state.resourceDetailItemIds, action.payload] };
    case 'POP_RESOURCE_DETAIL_ITEM':
      return { ...state, resourceDetailItemIds: state.resourceDetailItemIds.slice(0, -1) };
    case 'PUSH_COST_DETAIL_ITEM':
      return { ...state, costDetailItemIds: [...state.costDetailItemIds, action.payload] };
    case 'POP_COST_DETAIL_ITEM':
      return { ...state, costDetailItemIds: state.costDetailItemIds.slice(0, -1) };
    default:
      return state;
  }
};

export const useModalState = () => useReducer(modalReducer, modalInitialState);
